import { useCancelOrphanedSageEdit } from '../../hooks/useCancelOrphanedSageEdit';
import { useDealerSageMappingsQuery } from '../../hooks/useDealerSageMappingsQuery';
import { useSageMappingRowEditor } from '../../hooks/useSageMappingRowEditor';
import { DealerSageMappings } from './DealerSageMappings';

interface Props {
    dealerId: string;
    includesOwnedDealers: boolean;
}

export function DealerSageMappingsSection({ dealerId, includesOwnedDealers }: Props) {
    const query = useDealerSageMappingsQuery(dealerId);
    const editor = useSageMappingRowEditor(dealerId);
    useCancelOrphanedSageEdit({
        mappings: query.data,
        editingKey: editor.editingKey,
        isSaving: editor.isSaving,
        cancelEdit: editor.cancelEdit,
    });
    return (
        <DealerSageMappings
            mappings={query.data}
            isLoading={query.isLoading}
            isError={query.isError}
            onRetry={() => void query.refetch()}
            includesOwnedDealers={includesOwnedDealers}
            editor={editor}
        />
    );
}
